module.exports = __webpack_public_path__ + "assets/img/block-3b205d51.png";